<template>
    <div style="background-color: snow;  width: 100%;z-index: 999;position: -webkit-sticky;position: sticky;top: 0;">
        <a-row>
            <a-col :span="6">
                <logo_c/>
            </a-col>
            <a-col :span="18" style="padding-top: 3px">
                <a-menu style="background-color: snow;font-weight: bolder" v-model:selectedKeys="current"
                        mode="horizontal" :items="items" @click="clickMenuItem"/>
            </a-col>
        </a-row>
        <a-modal v-model:open="open" title="联系我们" @ok="handleOk" :footer="null">
            <p>电话：<a>17610833899</a> <a>13876562330</a></p>
            <p>微信：<a>17610833899</a></p>
            <p>
                <a-image :preview="false" width="150px"
                         src="wechat.png"
                />
            </p>
        </a-modal>
        <a-float-button
                @click="showModal"
                shape="square"
                type="primary"
                :style="{right: '24px',    }"
        >
            <template #icon>
                <CustomerServiceOutlined/>
            </template>
        </a-float-button>
    </div>
</template>

<script setup>
    import logo_c from './logo_c.vue';
    import {CustomerServiceOutlined} from '@ant-design/icons-vue';//SearchOutlined, ShoppingCartOutlined,
    import {API_sectionListBySectionTypeName} from '../api/api.js';
    import {ref, onMounted} from 'vue';//h,
    import {useRouter} from 'vue-router';

    const router = useRouter();
    const current = ref(['home']);
    const open = ref(false);

    const items = ref([
        {
            key: 'home',
            label: '青圆信息',
            title: '',
        },
        // {
        //     key: 'app',
        //     label: '软件定制及销售',
        //     title: '',
        // },
        // {
        //     key: 'tyre',
        //     label: '汽配及轮胎销售',
        //     title: '',
        // },
        // {
        //     key: 'pic',
        //     label: '摄影写真服务',
        //     title: '',
        // },
        // {
        //     key: 'help',
        //     label: '咨询与支持',
        //     title: '',
        // },
        // {
        //     key: 'search',
        //     label: '搜索',
        //     icon: () => h(SearchOutlined),
        //     title: '',
        // },
        // {
        //     key: 'shoppingCar',
        //     label: '购物车',
        //     icon: () => h(ShoppingCartOutlined),
        //     title: '',
        // },
    ]);

    onMounted(() => {
        getMenuList();
    });

    function getMenuList() {
        API_sectionListBySectionTypeName("首页菜单", 10).then(res => {
            if (res.success) {
                items.value = res.result.list.map(value => {
                    return {
                        key: value.link,
                        label: value.name,
                        title: '',
                        jumpType: value.jumpType,
                    }
                });
            }
        });
    }

    function clickMenuItem({item, key}) {
        var jumpType = items.value.find(value => value.key === key).jumpType;
        var label = items.value.find(value => value.key === key).label;

        if (item && jumpType === "route") {
            router.push(key)
        }
        if (item && label === '联系我们') {
            showModal();
        }
    }

    const showModal = () => {
        open.value = true;
    };
    const handleOk = () => {
        open.value = false;
    };

</script>

<style scoped>


</style>
